/* eslint-disable */
import UtilService from '@/utils/UtilService'
import Vue from 'vue'
import store from '@/store'
export default new Vue({
  methods: {
    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getCaptcha (act) {
      // Check grecaptch not exist
      return new Promise(async resolve => {
        if (!window.grecaptcha) {
          console.log('window is not ready, try to get new')
          await this.timeout(200)
          let result = await this.getCaptcha(act)
          resolve(result)
        } else {
          console.log('window is ready')
          let result = await this.request(act)
          resolve(result)
        }
      })
    },
    request (act) {
      return new Promise(resolve => {
        window.grecaptcha.ready(() => {
          const recapcha = store.getters.reCaptchaV3Key
          window.grecaptcha.execute(recapcha, { action: act })
            .then((token) => {
              // validate reCaptcha response
              if (!token) {
                console.log('Can not get token from api')
                resolve(UtilService.generateRandomString(334))
              }
              console.log('get new token from api: ', token)
              resolve(token)
            }, (error) => {
              console.log(error)
              resolve(UtilService.generateRandomString(334))
            })
        })
      })
    }
  }
})
